import { Box, Flex } from "@chakra-ui/react";
import React from "react";
import Packages from "../components/gigPage/Packages";
import Reviews from "../components/gigPage/Reviews";
import Profile from "../components/gigPage/Profile";
import CommonContainer from "../components/shared/CommonContainer";
import Recommended from "../components/gigPage/Recommended";
import GigDescriptionSection from "../components/gigPage/GigDescriptionSection";
import GigDetails from "../components/gigPage/GigDetails";
import ImageSlider from "../components/gigPage/ImageSlider";

export default function GigPage() {
  return (
    <CommonContainer>
      <Flex
        justifyContent="space-between"
        flexDir={{ base: "column", xl: "row" }}
        py={10}
        gap={10}
      >
        <Box w={{ xl: "55%" }}>
          <GigDetails />
          <ImageSlider />
          <GigDescriptionSection />
          <Box display={{ base: "none", md: "block" }}>
            <Recommended />
          </Box>
        </Box>
        <Box w={{ xl: "35%" }} maxW={{xl: "530px"}}>
          <Packages />
          <Reviews />
          <Profile />
        </Box>
      </Flex>
      <Box display={{ base: "block", md: "none" }}>
        <Recommended />
      </Box>
    </CommonContainer>
  );
}
